import { AvailableVehicles } from "./AvailableVehicles";

export class VehicleReserves extends AvailableVehicles{
    
}